import { ConstructedEvents } from '../constants';
import { BitrateChange, EventReport, PlayerEventReporter } from './interfaces';

const bitrateChangeHandler = (
  event: EventReport,
  reporter: PlayerEventReporter
): boolean => {
  if (event.e != ConstructedEvents.playbackbitratechanged.code) {
    return false;
  }
  const bc = reporter.config.report.max.bc;
  const len = reporter.pending.bitrates.data.length;
  const oldBitrate = reporter.state.b;
  const { b, t, ts: timestamp } = event;
  const ts = timestamp ?? Date.now();
  // We only want to add an event if the bitrate is not the same as previous,
  // not equal to -1, and is defined
  if (bc > len && b && b != -1 && oldBitrate != b) {
    reporter.state.novelData = true;
    const bitrateChange: BitrateChange = { b, t, ts };
    if (typeof event.s !== 'undefined') {
      bitrateChange.s = event.s;
    }
    reporter.pending.bitrates.data.push(bitrateChange);
    reporter.state.b = b;
  }
  return true;
};

export default bitrateChangeHandler;
